import { EmitLikeParams } from "../../domain/usecases/emitLike";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../core/store/store";
import { onEmitLike } from "../store/MatchThunk";
import { updateMatchesSearch } from "../store/MatchSlice";

const useMatch = () => {
	const dispatch: AppDispatch = useDispatch();
	const { matchesSearch } = useSelector((state: RootState) => state.match);

	const handleLike = async (user_id: string, type: "like" | "dislike") => {
		const params: EmitLikeParams = {
			userId: user_id,
			type: type === "like" ? "liked" : "rejected",
		};
		const result = await dispatch(onEmitLike(params));
		return onEmitLike.fulfilled.match(result);
	};

	const handleUpdateMatchesSearch = (idMatch: string) => {
        if (!matchesSearch) return;
        const updatedMatches = matchesSearch.matches.filter(
            (match) => match.id !== idMatch
        );
        dispatch(
            updateMatchesSearch({
                ...matchesSearch,
                matches: updatedMatches,
            })
        );
    }

	return {
		handleLike: (user_id: string, type: "like" | "dislike") => handleLike(user_id, type),
		handleUpdateMatchesSearch: (idMatch: string) => handleUpdateMatchesSearch(idMatch),
	};
};

export default useMatch;
